import { createRoutine, promisifyRoutine } from 'redux-saga-routines'

// Download WSDL
// Routine for Form
export const submitFormDownloadApiWsdlRoutine = createRoutine('DOWNLOAD_API_WSDL')
export const submitFinalFormDownloadApiWsdlHandler = promisifyRoutine(submitFormDownloadApiWsdlRoutine)
